import jwt_decode from "jwt-decode";
import Cookie from "./Cookie";

const tokenCookieName = "__token";

/**
 * Vérifie si un token existe et est valide (non expiré)
 */
export const isTokenValid = (token?: string | null): boolean => {
  try {
    const tokenToValidate = token ?? Cookie.get(tokenCookieName);
    if (!tokenToValidate) {
      return false;
    }

    // Vérifier l'expiration du token
    const expirationDate = getExpirationDate(tokenToValidate);
    if (expirationDate && expirationDate < new Date()) {
      return false;
    }

    // Vérifier que le token peut être décodé
    jwt_decode(tokenToValidate);
    return true;
  } catch (error) {
    return false;
  }
};

export const getExpirationDate = (
  token: string,
  tokenExpirationField = "exp",
  tokenTimestampShift = 1000
): Date | undefined => {
  let expires = jwt_decode<any>(token)[tokenExpirationField] as
    | Date
    | number
    | undefined;

  if (typeof expires === "number") {
    expires = new Date(expires * tokenTimestampShift);
  }

  return expires;
};
